module.exports = __webpack_public_path__ + "static/media/crypto.d3bcd409.png";